import React, { useState } from 'react';
import TreatmentInpatientSelection from './TreatmentInpatientSelection';
import TreatmentInpatientChart from './TreatmentInpatientChart';
import { Tabs, Tab, Box } from '@mui/material';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

interface TreatmentInpatientProps extends LocalizeContextProps {
    mode: string;
    variant?: "standard" | "filled" | "outlined" | undefined;
    size?: string;
    language: string;
    typeMargin?: any;
    type: string;
    uuidPatient?: string;
    uuidInvestigation?: string;
    slaves?: object[];
    country?: string;
    template?: string;
    cancel?: () => void;
    updateElement?: (index: number, element: any) => void;
    elementSelected: (element: any) => void;
    error: boolean;
    initialTreatments?: Array<any>;
    fieldInfo?: any;
    uuidSurvey?: string;
    idSubmission?: number;
    onSaveToDatabase?: (treatmentData: any) => Promise<void>;
    onUpdateDatabase?: (treatmentData: any) => Promise<void>;
    onDeleteDatabase?: (treatmentData: any) => Promise<void>;
}

const TreatmentInpatient: React.FC<TreatmentInpatientProps> = (props) => {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };
  
    if(props.initialTreatments?.length === 0) {
        return <TreatmentInpatientSelection 
                {...props}
                initialTreatments={props.initialTreatments}
                fieldInfo={props.fieldInfo}
                uuidSurvey={props.uuidSurvey}
                uuidPatient={props.uuidPatient}
                uuidInvestigation={props.uuidInvestigation}
                idSubmission={props.idSubmission}
                onSaveToDatabase={props.onSaveToDatabase}
                onUpdateDatabase={props.onUpdateDatabase}
                onDeleteDatabase={props.onDeleteDatabase}
            />
    }
    return (
        <Box>
            <Tabs 
            value={tabValue} 
            onChange={handleTabChange} 
            variant="scrollable" 
            scrollButtons="auto"
            aria-label="treatment tabs"
        >
            <Tab label={<Translate id="hospital.treatment-inpatient-medication-orders"/>} id="tab-0" aria-controls="tabpanel-0" />
            <Tab label={<Translate id="hospital.treatment-inpatient-medication-chart" />} id="tab-1" aria-controls="tabpanel-1" />
        </Tabs>
        
        <TabPanel value={tabValue} index={0}>
            <TreatmentInpatientSelection 
                {...props}
                initialTreatments={props.initialTreatments}
                fieldInfo={props.fieldInfo}
                uuidSurvey={props.uuidSurvey}
                uuidPatient={props.uuidPatient}
                uuidInvestigation={props.uuidInvestigation}
                idSubmission={props.idSubmission}
                onSaveToDatabase={props.onSaveToDatabase}
                onUpdateDatabase={props.onUpdateDatabase}
                onDeleteDatabase={props.onDeleteDatabase}
            />
        </TabPanel>
        
        <TabPanel value={tabValue} index={1}>
            <TreatmentInpatientChart
                initialTreatments={props.initialTreatments}
                patientUuid={props.uuidPatient}
                uuidInvestigation={props.uuidInvestigation}
                language={props.language}
            />
        </TabPanel>
    </Box>
    );
};

export default withLocalize(TreatmentInpatient);
